var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-template-single-default",class:{
    'iconed': _vm.leftIcon,
    'colored': _vm.displayColor
  }},[(_vm.leftIcon)?_c('p4a-icon',{staticClass:"left-icon",attrs:{"icon":_vm.leftIcon}}):_vm._e(),_vm._v(" "),(_vm.displayColor)?_c('div',{staticClass:"color-swatch",class:{
      'clear': !_vm.colorValue
    },style:({
      'background-color': _vm.colorValue
    })}):_vm._e(),_vm._v(" "),(_vm.value)?_c('label',{staticClass:"current-value",attrs:{"title":_vm.displayText},domProps:{"textContent":_vm._s(_vm.displayText)}}):_vm._e(),_vm._v(" "),(!_vm.value)?_c('label',{staticClass:"search-placeholder",domProps:{"textContent":_vm._s(_vm.placeHolder)}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e57eb02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/pro4all-ui/sns-components/kit-components/input-templates/selection/display-templates/default/DisplayTemplateSingleDefault.vue
// module id = null
// module chunks = 